import type { TOC } from '@ember/component/template-only';
import DatePickerDropdown from 'garaje/components/date-picker-dropdown';
import type { DatePickerDropdownSignature } from 'garaje/components/date-picker-dropdown';
import DatePickerOptions from 'garaje/components/date-picker-options';

export default <template>
  <DatePickerDropdown
    @rangeOptions={{@rangeOptions}}
    @startDate={{@startDate}}
    @dateFormat={{@dateFormat}}
    @dateLimits={{@dateLimits}}
    @showTimePicker={{@showTimePicker}}
    @showTimezonePicker={{@showTimezonePicker}}
    @endDate={{@endDate}}
    @onDateSelected={{@onDateSelected}}
    @onDateRangeSelected={{@onDateRangeSelected}}
    @onTimezoneChange={{@onTimezoneChange}}
    @setStartDate={{@setStartDate}}
    @setEndDate={{@setEndDate}}
    @onGoBackOneMonth={{@onGoBackOneMonth}}
    @onGoToNextMonth={{@onGoToNextMonth}}
    @shortcuts={{@shortcuts}}
    @timezone={{@timezone}}
    @events={{@events}}
    @dropdownOptions={{@dropdownOptions}}
    @onOpen={{@onOpen}}
    ...attributes
  >
    <:date-picker-dropdown-left-sidebar as |sidebar|>
      <DatePickerOptions
        @options={{sidebar.options}}
        @selectedOption={{sidebar.selectedOption}}
        @highlightedOption={{sidebar.highlightedOption}}
        @dropdownId={{sidebar.dropdownId}}
        @highlightedIndex={{sidebar.highlightedIndex}}
        @onOptionSelect={{sidebar.onOptionSelect}}
        @onListboxFocus={{sidebar.onListboxFocus}}
        @close={{sidebar.close}}
      />
    </:date-picker-dropdown-left-sidebar>
  </DatePickerDropdown>
</template> satisfies TOC<DatePickerDropdownSignature>;
